// @flow
import * as React from "react";

type Props = {
  type: string,
  message: string
};

const Alert = function(props: Props) {
  return (
    <div className={"alert alert-" + props.type} role="alert">
      {props.message}
    </div>
  );
};

export default Alert;



// WEBPACK FOOTER //
// ./app/javascript/components/alert.jsx